<template>
  <div v-if="wrapshow">
    <van-popup v-model="open" position="bottom" @closed="wrapshow = false">
      <van-picker
        show-toolbar
        :title="title"
        :value-key="valueKey"
        :default-index="defaultIndex"
        :columns="list"
        @confirm="confirm"
        @cancel="close"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'DictionaryPicker',
  data() {
    return {
      wrapshow: true,
      open: false,
      loading: true,
      list: [],
      title: "",
      valueKey: "dictName",
      defaultIndex: 0,
    };
  },
  methods: {
    showPicker(opts = {}) {
      return new Promise((resolve) => {
        this.wrapshow = true;
        this.open = true;

        this.list = opts.list || [];
        this.valueKey = opts.valueKey || "dictName";
        this.title = opts.title || "";
        if (opts.default != undefined) {
          this.defaultIndex = this.list.findIndex(v=>v.id===opts.default);
        }

        this._resolve = resolve;
      });
    },
    close(e) {
      this.open = false;
    },
    confirm(e) {
      this.close();
      this._resolve(e);
    },
  },
  created() {
    
  },
};
</script>
